import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HomepageService {

  constructor(private _httpClient: HttpClient) { }

  getListNews(page: number, size: number): Observable<any> {
    return this._httpClient.get<any>(`actualite/${page}/${size}`).pipe(map((res: any) => res));
  }
  getNewsDetail(id: string): Observable<any> {
    return this._httpClient.get<any>(`actualite/${id}`).pipe(map((res: any) => res));
  }
  getCountry(): Observable<any> {
    return this._httpClient.get<any>('parametre/nomtable/COUNTRY').pipe(map((res: any) => res));
  }
}
